import { render, staticRenderFns } from "./PayrollCalendar.vue?vue&type=template&id=6fc5f2f8&"
import script from "./PayrollCalendar.vue?vue&type=script&lang=js&"
export * from "./PayrollCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports